import axios from 'axios';

import { BASE_URL } from './Constants';

const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export async function putSerie(body) {
  try {
    const response = await instance.put(`/serie/add`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function putEpisode(body, idSeason, epNumber) {
  try {
    const response = await instance.put(`/episode/add?idSeason=${idSeason}&epNum=${epNumber}`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function putSaison(body, idSerie) {
  try {
    const response = await instance.put(`/${idSerie}/saison`, body);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function putAccountStatus(body) {
  try {
    const response = await instance.put(`/manage/account`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
}


export async function reloadClasses(body) {
  try {
    const response = await instance.put(`/edifice/reload/classes`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
}

export async function putTransitionConfig(body) {
  try {
    const response = await instance.put(`/edifice/transition/config`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "La configuration n'a pas pu être enregistrée" };
  }
}

export async function putWebappCodeMetadata(code, body) {
  try {
    const response = await instance.put(`/manage/webappcode/${encodeURIComponent(code)}`, body);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: "Les informations n'ont pas pu être enregistrées" };
  }
}
